import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeGetEmbeddingModels = (repo: KnowledgeBaseRepository) =>
  () =>
    repo.getEmbeddingModels()
